module.exports = __webpack_public_path__ + "img/coach-workout-plan.7df9d3ad.svg";